/* @flow */

export const HISCON_GET_REQUEST = 'HISCON_GET_REQUEST';
export const HISCON_GET_SUCCESS = 'HISCON_GET_SUCCESS';
export const HISCON_GET_FAILURE = 'HISCON_GET_FAILURE';

export function success(payload) {
  return (dispatch) => {
    dispatch({
      type: HISCON_GET_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  return (dispatch) => {
    dispatch({
      type: HISCON_GET_FAILURE,
      payload: resource,
    });
  };
}

export default function GET(params) {
  return (dispatch) => {
    dispatch({
      type: HISCON_GET_REQUEST,
      payload: params,
    });
  };
}
